<template>
  <div class="card_flex">
    <div class="filter">
      <div class="input_wrap">
        <fg-input
            v-model="searchword"
            type="text"
            class=""
            :label="translate('custom.search')"
            :placeholder="translate('custom.search')"
            :clearable="true"
            @keyup.enter="search"
        />
      </div>

      <button
        class="btn btn-success"
        @click="search"
      >
        {{ translate('search') }}
      </button>
    </div>
    <div class="group_list custom_group_list">
      <v-tree style="margin-top: 10px; margin-left: 30px" ref='tree1' :canDeleteRoot="true" :data='groupTree' :draggable='true'  :tpl='tpl' />
    </div>
  </div>
</template>

<script>
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'CustomDeviceListGroups',
  components: {
  },
  data () {
    return {
      new_group: {},
      searchword: '',
      search_group: [],
      choice_group: []
    }
  },
  computed: {
    groupTree () {
      return  [{
        expanded: true,
        id: -1,
        label: 'all list',
        name: 'all list',
        children: this.$store.getters.getCustomListTree
      }]
    }
  },

  watch: {
    groupTree () {
      if(this.new_group.id !== undefined) {
        setTimeout(() => {
          this.$refs.tree1.searchNodes((node) => {
            if (node.id === this.new_group.id) {
              this.choice(node)
              node.searched = true
              this.new_group = {}
            }
          })
        }, 500);
      }
      if(this.choice_group.id !== undefined) {
        setTimeout(() => {
          this.$refs.tree1.searchNodes((node) => {
            if (node.id === this.choice_group.id) {
              this.choice(node)
            }
          })
        }, 500);
      }
    }
  },

  methods: {
    confirm_delete (node, parent, index) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('custom.ask_list_deleted')
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_delete_custom_list')
          },
          confirm: () => {
            this.delete(node, parent, index)
            this.$modal.hide('confirm_delete_custom_list')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'confirm_delete_custom_list'
      })

    },
    search () {
      if(this.searchword.trim() === '') {
        this.$refs.tree1.searchNodes()
        return true
      }
      this.$refs.tree1.searchNodes((node) => {
        let name = node.name.toLowerCase()
        return name.indexOf(this.searchword.toLowerCase()) !== -1 }
      )
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      let begin = (parent == null) ? <button class="treebtn1" onClick={() => this.add()}>+</button> : ''
      let cross = (parent !== null) ? <span class="mdi mdi-close-box red" onClick={() => this.confirm_delete(node, parent, index)} title="delete"/> : ''
      return <span>
        {begin}
         <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
           if(parent == null) {
             this.clear()
           }
           this.$refs.tree1.nodeSelected(node);
           this.choice(node)
         }}></span>
        {cross}
      </span>
    },

    choice (group) {
      this.choice_group = group
      this.$emit('choice', group)
    },

    clear(){
      this.choice({})
    },

    delete (node) {
      this.$http.v1.deleteCustomDeviceList(node.id, () => {
        this.global_notify('info', this.translate('custom.delete_list_success'))
        this.$store.dispatch('customListUpdate')

        if (this.choice_group.id === node.id){
          this.clear()
        }

      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.$store.dispatch('customListUpdate')
      })
    },

    add () {
      let new_list = {
        "id": null,
        "name": "!New List",
        "description": "!Description",
        "devices": [],
        "users": []
      }
      this.$http.v1.createCustomDeviceList(new_list, (resp) => {
        this.global_notify('info', this.translate('custom.add_list_success'))
        this.$emit('update')

        this.$store.dispatch('customListUpdate');
        this.new_group = resp.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.card_flex {
  overflow: hidden;
  padding: 10px;
  .filter {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 10px;
    .input_wrap{
      position: relative;
      width: 80%;
      .form-group{
        margin-bottom: 0;
      }
      .clear{
        position: absolute;
        right: 0;
        bottom: 0;
        height: 40px;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #66615b;
        font-weight: bold;
        cursor: pointer;
        &:hover{
          color: #e53935;
        }
      }
    }

    .btn{
      width: 15%;
      padding: 7px;
      height: 40px;
    }
  }
  .group_list {
    overflow: auto;
    width: 100%;
    flex: 12;
    border: 1px solid #DCDCDC;
    color: black;
  }
  .group_list .halo-tree li.leaf{
    padding-top: 4px;
  }
}

@media (max-width: 768px) {
  .card_flex {
    padding: 10px 0;
    .filter {
      .form-group{
        width: 70%;
        margin-right: 10px;
      }
      .btn{
        width: 30%;
      }
    }
    .group_list {
      overflow: auto;
      width: 100%;
      flex: 12;
      border: 1px solid #DCDCDC;
    }
  }
}
</style>
